import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import App from "./App";
import { Store } from "./redux/Store";

if (process.env.NODE_ENV === 'development') {
  const origError = console.error;
  console.error = (...args) => {
    if (args.some(arg => 
      typeof arg === 'string' && 
      arg.includes('ResizeObserver loop completed with undelivered notifications')
    )) {
      return;
    }
    origError(...args);
  };
}

// 2. Handle uncaught errors
window.addEventListener('error', (event) => {
  if (event.message === 'ResizeObserver loop completed with undelivered notifications.') {
    event.stopImmediatePropagation();
    return false;
  }
});

ReactDOM.render(
  <Provider store={Store}>
    <App />
  </Provider>,
  document.getElementById("root")
);